"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroSection() {
  const {
    ref: headlineRef,
    isVisible: isHeadlineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: buttonsRef,
    isVisible: isButtonsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero-section" className="relative w-full bg-[var(--background-light)] py-20 md:py-24 flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,var(--color-border)_1px,transparent_1px)] [background-size:40px_40px] opacity-20" />

      <div className="container relative z-10 px-4 md:px-6 mx-auto text-center flex flex-col items-center">
        <h1 ref={headlineRef} className={`font-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-medium tracking-tight text-foreground mb-4 max-w-4xl mx-auto transition-all duration-1000 ease-out ${isHeadlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          Specialized Linguistic Solutions
        </h1>

        <p ref={textRef} className={`font-default text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto mb-6 leading-relaxed transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          At GLYPHIC S.A.S., we deliver precision language services for medical
          and legal sectors, ensuring HIPAA compliance, legal accuracy, and
          seamless communication across languages.
        </p>

        <div ref={buttonsRef} className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-1000 delay-400 ease-out ${isButtonsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="rounded-full px-8 h-12 text-base">
            
          </Button>
          <Button asChild variant="default" size="lg" className="rounded-full px-8 h-12 text-base">
            <Link to="/ConnectPage">Contact Us</Link>
          </Button>
        </div>
      </div>
    </section>;
}